module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./de-DE.coffee"));
	}, "locale/de-DE");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=locale/[name]!./app/locale/de-DE.coffee
// module id = 257
// module chunks = 97